import React, { useState } from 'react';
import { protestService } from '../services/api';
import PhotoUpload from '../components/PhotoUpload';
import styles from './AddProtest.module.css';

export default function AddProtest() {
    const [form, setForm] = useState({
        text: '',
        protest_date: new Date().toISOString().split('T')[0],
        photos: [],
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);

        const data = new FormData();
        data.append('text', form.text);
        data.append('protest_date', form.protest_date);
        form.photos.forEach((file, i) => data.append(`photos[${i}]`, file));

        try {
            const res = await protestService.create(data);
            const warning = res.data?.warning;
            setMessage({
                type: warning ? 'warning' : 'success',
                text: warning
                    ? 'تم الحفظ — تنبيه: خدمة الذكاء الاصطناعي غير متاحة، يرجى تحديث التفاصيل يدوياً.'
                    : 'تم إضافة التظاهرة بنجاح ✓',
            });
            setForm({ text: '', protest_date: new Date().toISOString().split('T')[0], photos: [] });
        } catch (err) {
            setMessage({
                type: 'error',
                text: 'خطأ: ' + (err.response?.data?.error || err.response?.data?.message || err.message),
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`${styles.container} text-ar`}>
            <div className={styles.header}>
                <h1>إضافة تظاهرة جديدة</h1>
                <p>أدخل البيانات أدناه — سيستخرج الذكاء الاصطناعي التفاصيل تلقائياً</p>
            </div>

            {message && (
                <div className={`${styles.alert} ${styles[message.type]}`}>
                    {message.text}
                </div>
            )}

            <form onSubmit={handleSubmit} className={styles.form}>
                <div className={styles.field}>
                    <label className={styles.label}>التاريخ</label>
                    <input
                        type="date"
                        value={form.protest_date}
                        onChange={(e) => setForm({ ...form, protest_date: e.target.value })}
                        className={styles.input}
                        required
                    />
                </div>

                <div className={styles.aiBox}>
                    <div className={styles.aiHeader}>
                        <span className={styles.aiIcon}>🤖</span>
                        <div>
                            <h3 className={styles.aiTitle}>محلل الاحتجاجات بالذكاء الاصطناعي</h3>
                            <p className={styles.aiSubtitle}>أدخل نصاً والذكاء الاصطناعي سيستخرج البيانات تلقائياً</p>
                        </div>
                    </div>
                    <textarea
                        value={form.text}
                        onChange={(e) => setForm({ ...form, text: e.target.value })}
                        placeholder="مثال: رصدنا احتجاجاً في دمشق في ساحة الأمويين شارك فيه آلاف الأشخاص يطالبون بإسقاط المرسوم 66..."
                        rows={5}
                        className={styles.aiTextarea}
                        required
                    />
                </div>

                <div className={styles.field}>
                    <label className={styles.label}>
                        الصور <span className={styles.optional}>(اختياري — تُستخرج الإحداثيات من EXIF)</span>
                    </label>
                    <PhotoUpload
                        photos={form.photos}
                        multiple={true}
                        onChange={(files) => setForm({ ...form, photos: files })}
                    />
                </div>

                <button
                    type="submit"
                    disabled={loading || !form.text}
                    className={styles.submitBtn}
                >
                    {loading ? 'جاري الإرسال...' : 'إضافة التظاهرة'}
                </button>
            </form>
        </div>
    );
}
